module.exports = __webpack_public_path__ + "img/favicon.a64c7abe.png";